"use strict";
/*
 * Created on 10 19 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var VendorAllowance_1 = require("../model/VendorAllowance");

var VendorAllowanceConverter_1 = require("./VendorAllowanceConverter");
/**
 * Implementation of {@link VendorAllowanceConverter}
 *
 * @author JMe
 */


var VendorAllowanceConverterImpl =
/*#__PURE__*/
function (_VendorAllowanceConve) {
  _inherits(VendorAllowanceConverterImpl, _VendorAllowanceConve);

  function VendorAllowanceConverterImpl() {
    _classCallCheck(this, VendorAllowanceConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(VendorAllowanceConverterImpl).apply(this, arguments));
  }

  _createClass(VendorAllowanceConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new VendorAllowance_1.VendorAllowance(VendorAllowance_1.VendorAllowance.schema.id.valueOf(conversions.documentToClassId(source)), VendorAllowance_1.VendorAllowance.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), VendorAllowance_1.VendorAllowance.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), VendorAllowance_1.VendorAllowance.schema.validFrom.valueOf(conversions.toDate(source.validFrom)), VendorAllowance_1.VendorAllowance.schema.validTo.valueOf(conversions.toDate(source.validTo)), VendorAllowance_1.VendorAllowance.schema.withBackBonus.valueOf(utils_1.Utils.isValueMissing(source.withBackBonus) ? null : conversions.toBigNumber(source.withBackBonus)), VendorAllowance_1.VendorAllowance.schema.withoutBackBonus.valueOf(utils_1.Utils.isValueMissing(source.withoutBackBonus) ? null : conversions.toBigNumber(source.withoutBackBonus)), VendorAllowance_1.VendorAllowance.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo),
        withBackBonus: source.withBackBonus === null ? null : conversions.fromBigNumber(source.withBackBonus),
        withoutBackBonus: source.withoutBackBonus === null ? null : conversions.fromBigNumber(source.withoutBackBonus),
        processed: source.processed
      });
      return result;
    }
  }]);

  return VendorAllowanceConverterImpl;
}(VendorAllowanceConverter_1.VendorAllowanceConverter);

exports.VendorAllowanceConverterImpl = VendorAllowanceConverterImpl;